import { useFormik } from 'formik'
import { NumericFormat } from 'react-number-format'
import ModalComponent from '..'
import { parseCurrencyToNumber } from '../../../helpers'
import { useUpdateProductGiftEligibilityMutation } from '../../../redux-toolkits/products/products.slice'
import { Product } from '../../../redux-toolkits/products/products.type'
import { updateProductGiftEligibilitySchema } from '../../../validation/validate'
import { Button } from '../../button'
import { Checkbox } from '../../inputs/Checkbox'
import { TextInput } from '../../inputs/textInput'

export const ProductGiftingModal = ({
  open,
  closeModal,
  product,
  onSuccess,
}: {
  open: boolean
  closeModal: () => void
  product: Product
  onSuccess: () => void
}) => {
  const [updateProductGiftEligibility, { isLoading: updating }] =
    useUpdateProductGiftEligibilityMutation()

  const {
    values,
    handleBlur,
    handleChange,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    resetForm,
    isValid,
  } = useFormik({
    initialValues: {
      isGift: product?.freeGift?.isEligible ?? false,
      stock: product?.freeGift?.stock ?? '',
    },
    enableReinitialize: true,
    validationSchema: updateProductGiftEligibilitySchema,
    onSubmit: async (vals) => {
      const resp = await updateProductGiftEligibility({
        productId: product._id,
        isEligible: vals.isGift,
        stock: parseCurrencyToNumber(vals.stock) ?? 0,
      })

      if (resp.data?.success) {
        onSuccess()
      }
    },
  })

  return (
    <ModalComponent
      title={`Manage Product Gifting`}
      open={open}
      setOpen={() => {}}
      onCloseCallback={() => {
        closeModal()
        resetForm()
      }}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="grid grid-cols-1 gap-4 ">
        <Checkbox
          checkStatus={values.isGift}
          text="Mark as gift?"
          handleChange={async (status) => {
            setFieldValue('isGift', status)
          }}
          className="w-full"
        />

        {values.isGift ? (
          <NumericFormat
            suffix={undefined}
            prefix={undefined}
            customInput={TextInput}
            type="text"
            name="stock"
            title="Gift stock"
            placeholder="Enter gift stock"
            value={values.stock}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={errors.stock && touched.stock ? errors.stock : ''}
            hasIcon={false}
            decimalScale={2}
            thousandSeparator
          />
        ) : undefined}

        <Button
          disabled={updating || !isValid}
          loading={updating}
          type="button"
          label="Save"
          primary
          className="!mt-6 !w-full col-span-full"
          onClick={() => {
            handleSubmit()
          }}
        />
      </div>
    </ModalComponent>
  )
}
